module.exports = __webpack_public_path__ + "static/media/4.ff6bef14.jpg";